import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Link as ScrollLink } from 'react-scroll';

@inject('SiteStore') @observer
export default class Submenu extends Component {
  constructor(props) {
    super(props);
    this.state = { menuFixed: false };
    this.handleScroll = this.handleScroll.bind(this);
    this.elementPosition = 0;
  }

  handleScroll(event) {
    const scrollFromTop = document.body.scrollTop || document.body.parentNode.scrollTop;

    const { SiteStore } = this.props;
    //const scrollTop = SiteStore.isMobileResolution ? SiteStore.submenuTop-180 : 380;
    const scrollTop = SiteStore.isMobileResolution ? SiteStore.submenuTop+58 : 380;

    this.setState({ menuFixed: scrollFromTop > scrollTop });
  }

  componentWillMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentDidMount() {
    const { SiteStore } = this.props;
    SiteStore.setSubmenuTop(this.refs.submenu.getBoundingClientRect().top);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  render() {
    const scrollLinkDefaultProps = {
      spy: true,
      smooth: true,
      duration: 500,
      onSetActive: (to) => {
        const left = this.refs[to].offsetLeft;
        this.refs.mobileScroll.scroll(left-50,0);
      }
    };

    const { menuFixed } = this.state;
    const { links } = this.props;

    return (
      <div className="Container-Submenu" ref="submenu">
        <div className={ menuFixed ? 'Wrapper-Submenu Fixed' : 'Wrapper-Submenu'}>
          <nav className="Scroll-Menu">
            <ul className="Mob-Scroll" ref="mobileScroll">
            {
              links.map((link) => {
                return (
                  <li key={`link-${link.to}`} ref={link.to}>
                    <ScrollLink {...scrollLinkDefaultProps} to={link.to} title={link.title.replace('<br/>', '')} offset={link.offset}>
                      <span dangerouslySetInnerHTML={{
                        __html: link.title
                      }} />
                      <hr/>
                    </ScrollLink>
                  </li>
                )
              })
            }
            </ul>
          </nav>
          <hr className="Divisao"/>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Submenu.js